import { render, staticRenderFns } from "./xinZengRenShu.vue?vue&type=template&id=6a99dc3f&scoped=true"
import script from "./xinZengRenShu.vue?vue&type=script&lang=js"
export * from "./xinZengRenShu.vue?vue&type=script&lang=js"
import style0 from "./xinZengRenShu.vue?vue&type=style&index=0&id=6a99dc3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99dc3f",
  null
  
)

export default component.exports